import { TRANSLATION_KEYS } from 'legacy/lut/components/widgets/public/partner360/actionsPlan/keyInitiatives/translations'
import { FC } from 'react'

import { FormDropdown } from 'cng-common/features/form'
import { ValidationType } from 'cng-common/features/form/configs'

import { getActivityTypeCrud } from './helpers/getActivityTypeCrud'

interface IActivityTypeProps {
  initialValue?: string
  isDisabled?: boolean
  className?: string
  formKey: string
  onChange?: (activityType: string) => void
}

export const ActivityType: FC<IActivityTypeProps> = ({
  initialValue = '',
  isDisabled,
  className,
  formKey,
  onChange,
}) => {
  const crudDropdown = getActivityTypeCrud()

  return (
    <FormDropdown
      isStatic
      isRequired
      formKey={formKey}
      field="activityType"
      defaultValue={initialValue}
      classes={{ controlClasses: { root: className } }}
      source={crudDropdown}
      caption="value"
      label={TRANSLATION_KEYS.keyInitiativeEditor.keyInitiativeAndPeriodFieldGroup.activityType}
      isDisabled={isDisabled}
      onChange={onChange}
      validationType={ValidationType.ONCHANGE}
    />
  )
}
